export const keyFeaturesMockEditorial = {
    title: 'Key Features Editorial',
    description: 'Key Features Description',
    cards: [
        {
            _content_type_uid: 'key_features_card',
            uid: 'blt182c76d65df9f485',
            title: 'Key Features Card 1',
            header_copy: 'Key Features Card 1',
            body_copy:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla ornare ligula vitae elit pretium iaculis.',
            image: {
                uid: 'blte9febca7c08ea2a4',
                _version: 1,
                title: 'moodboard-image.png',
                created_by: 'blt4d4b6f28195c5c39',
                updated_by: 'blt4d4b6f28195c5c39',
                created_at: '2025-01-27T12:15:32.943Z',
                updated_at: '2025-01-27T12:15:32.943Z',
                content_type: 'image/png',
                file_size: '873416',
                filename: 'moodboard-image.png',
                ACL: {},
                parent_uid: null,
                is_dir: false,
                tags: [],
                publish_details: {
                    time: '2025-01-27T12:15:52.134Z',
                    user: 'blt4d4b6f28195c5c39',
                    environment: 'bltb1a0132ae7565d0b',
                    locale: 'en',
                },
                url: 'https://eu-images.contentstack.com/v3/assets/blt2252ade9ce4d4191/blte9febca7c08ea2a4/679778e4daf3057e01a09225/moodboard-image.png',
            },
            iscategorylink: true,
            psp_url: [],
            categorysfcc: {
                data: [
                    {
                        id: 'air-comfort',
                        name: 'Air Comfort',
                        onlineSubCategoriesCount: 0,
                        parentCategoryId: 'root',
                        parentCategoryTree: [
                            {
                                id: 'air-comfort',
                                name: 'Air Comfort',
                            },
                        ],
                    },
                ],
                type: 'sfcc_category',
            },
            categorylabel: '',
            link: {
                title: '',
                href: '',
            },
            tags: [],
            locale: 'en',
            created_by: 'blt42386adbe5183fd2',
            updated_by: 'blt42386adbe5183fd2',
            created_at: '2025-02-20T13:26:51.350Z',
            updated_at: '2025-02-20T13:28:06.856Z',
            ACL: {},
            _version: 2,
            _in_progress: false,
            publish_details: {
                time: '2025-02-20T13:32:14.888Z',
                user: 'blt42386adbe5183fd2',
                environment: 'bltb1a0132ae7565d0b',
                locale: 'en',
            },
        },
        {
            _content_type_uid: 'key_features_card',
            uid: 'bltb5894d68e60a56ca',
            title: 'Key Features Card 2',
            header_copy: 'Key Features Card 2',
            body_copy:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla ornare ligula vitae elit pretium iaculis. Phasellus posuere mauris eget sem laoreet dapibus.',
            image: {
                uid: 'blte9febca7c08ea2a4',
                _version: 1,
                title: 'moodboard-image.png',
                created_by: 'blt4d4b6f28195c5c39',
                updated_by: 'blt4d4b6f28195c5c39',
                created_at: '2025-01-27T12:15:32.943Z',
                updated_at: '2025-01-27T12:15:32.943Z',
                content_type: 'image/png',
                file_size: '873416',
                filename: 'moodboard-image.png',
                ACL: {},
                parent_uid: null,
                is_dir: false,
                tags: [],
                publish_details: {
                    time: '2025-01-27T12:15:52.134Z',
                    user: 'blt4d4b6f28195c5c39',
                    environment: 'bltb1a0132ae7565d0b',
                    locale: 'en',
                },
                url: 'https://eu-images.contentstack.com/v3/assets/blt2252ade9ce4d4191/blte9febca7c08ea2a4/679778e4daf3057e01a09225/moodboard-image.png',
            },
            iscategorylink: true,
            psp_url: [
                {
                    _content_type_uid: 'psp_url',
                    uid: 'blt305c59797b4c3951',
                    title: 'PSP test 1',
                    url: '/category/accessories',
                    tags: [],
                    locale: 'en',
                    created_by: 'blt42386adbe5183fd2',
                    updated_by: 'blt42386adbe5183fd2',
                    created_at: '2025-01-30T15:28:26.269Z',
                    updated_at: '2025-01-30T15:29:10.704Z',
                    ACL: {},
                    _version: 2,
                    _in_progress: false,
                    publish_details: {
                        time: '2025-01-30T15:38:14.788Z',
                        user: 'blt42386adbe5183fd2',
                        environment: 'bltb1a0132ae7565d0b',
                        locale: 'en',
                    },
                },
            ],
            categorysfcc: {
                data: [
                    {
                        id: 'accessories_coffeecupsandmugs',
                        name: 'Coffee cups and mugs',
                        onlineSubCategoriesCount: 0,
                        parentCategoryId: 'accessories',
                        parentCategoryTree: [
                            {
                                id: 'accessories',
                                name: 'Accessories',
                            },
                            {
                                id: 'accessories_coffeecupsandmugs',
                                name: 'Coffee cups and mugs',
                            },
                        ],
                    },
                ],
                type: 'sfcc_category',
            },
            categorylabel: 'Custom Label',
            link: {
                title: '',
                href: '',
            },
            tags: [],
            locale: 'en',
            created_by: 'blt42386adbe5183fd2',
            updated_by: 'blt42386adbe5183fd2',
            created_at: '2025-02-20T13:28:18.262Z',
            updated_at: '2025-02-20T13:29:04.643Z',
            ACL: {},
            _version: 2,
            _in_progress: false,
            publish_details: {
                time: '2025-02-20T13:32:14.874Z',
                user: 'blt42386adbe5183fd2',
                environment: 'bltb1a0132ae7565d0b',
                locale: 'en',
            },
        },
        {
            _content_type_uid: 'key_features_card',
            uid: 'bltcfa9180c063cbc90',
            title: 'Key Features Card 3',
            header_copy: 'Key Features Card 3',
            body_copy: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. ',
            image: {
                uid: 'bltf1d05b9594cf9456',
                _version: 3,
                title: 'cappuccino.png',
                created_by: 'blt4d4b6f28195c5c39',
                updated_by: 'blt4d4b6f28195c5c39',
                created_at: '2025-01-17T11:56:36.769Z',
                updated_at: '2025-01-17T11:57:49.430Z',
                content_type: 'image/png',
                file_size: '382116',
                filename: 'other-lg.png',
                ACL: {},
                parent_uid: null,
                is_dir: false,
                tags: [],
                description: 'cappuccino image',
                publish_details: {
                    time: '2025-01-17T11:59:10.291Z',
                    user: 'blt4d4b6f28195c5c39',
                    environment: 'bltb1a0132ae7565d0b',
                    locale: 'en',
                },
                url: 'https://eu-images.contentstack.com/v3/assets/blt2252ade9ce4d4191/bltf1d05b9594cf9456/678a4574c06ae40f2010ad34/other-lg.png',
            },
            iscategorylink: false,
            psp_url: [],
            categorysfcc: {
                type: 'sfcc_category',
            },
            categorylabel: '',
            link: {
                title: 'Simple Link',
                href: '/some-url',
            },
            tags: [],
            locale: 'en',
            created_by: 'blt42386adbe5183fd2',
            updated_by: 'blt42386adbe5183fd2',
            created_at: '2025-02-20T13:29:13.708Z',
            updated_at: '2025-02-20T13:29:55.536Z',
            ACL: {},
            _version: 2,
            _in_progress: false,
            publish_details: {
                time: '2025-02-20T13:32:14.859Z',
                user: 'blt42386adbe5183fd2',
                environment: 'bltb1a0132ae7565d0b',
                locale: 'en',
            },
        },
        {
            _content_type_uid: 'key_features_card',
            uid: 'blt91f67277e572729a',
            title: 'Key Features Card 4',
            header_copy: 'Key Features Card 4',
            body_copy: 'lorem',
            image: {
                uid: 'blte9febca7c08ea2a4',
                _version: 1,
                title: 'moodboard-image.png',
                created_by: 'blt4d4b6f28195c5c39',
                updated_by: 'blt4d4b6f28195c5c39',
                created_at: '2025-01-27T12:15:32.943Z',
                updated_at: '2025-01-27T12:15:32.943Z',
                content_type: 'image/png',
                file_size: '873416',
                filename: 'moodboard-image.png',
                ACL: {},
                parent_uid: null,
                is_dir: false,
                tags: [],
                publish_details: {
                    time: '2025-01-27T12:15:52.134Z',
                    user: 'blt4d4b6f28195c5c39',
                    environment: 'bltb1a0132ae7565d0b',
                    locale: 'en',
                },
                url: 'https://eu-images.contentstack.com/v3/assets/blt2252ade9ce4d4191/blte9febca7c08ea2a4/679778e4daf3057e01a09225/moodboard-image.png',
            },
            iscategorylink: false,
            psp_url: [],
            categorysfcc: {
                type: 'sfcc_category',
            },
            categorylabel: '',
            link: {
                title: 'simple 2',
                href: '/',
            },
            tags: [],
            locale: 'en',
            created_by: 'blt42386adbe5183fd2',
            updated_by: 'blt42386adbe5183fd2',
            created_at: '2025-02-20T13:31:07.674Z',
            updated_at: '2025-02-20T13:31:41.962Z',
            ACL: {},
            _version: 2,
            _in_progress: false,
            publish_details: {
                time: '2025-02-20T13:32:14.900Z',
                user: 'blt42386adbe5183fd2',
                environment: 'bltb1a0132ae7565d0b',
                locale: 'en',
            },
        },
        {
            _content_type_uid: 'key_features_card',
            uid: 'blt53acd8e18373c6f9',
            title: 'Key Features Card 5',
            header_copy: 'Key Features Card 5',
            body_copy: 'lorem',
            image: {
                uid: 'blte9febca7c08ea2a4',
                _version: 1,
                title: 'moodboard-image.png',
                created_by: 'blt4d4b6f28195c5c39',
                updated_by: 'blt4d4b6f28195c5c39',
                created_at: '2025-01-27T12:15:32.943Z',
                updated_at: '2025-01-27T12:15:32.943Z',
                content_type: 'image/png',
                file_size: '873416',
                filename: 'moodboard-image.png',
                ACL: {},
                parent_uid: null,
                is_dir: false,
                tags: [],
                publish_details: {
                    time: '2025-01-27T12:15:52.134Z',
                    user: 'blt4d4b6f28195c5c39',
                    environment: 'bltb1a0132ae7565d0b',
                    locale: 'en',
                },
                url: 'https://eu-images.contentstack.com/v3/assets/blt2252ade9ce4d4191/blte9febca7c08ea2a4/679778e4daf3057e01a09225/moodboard-image.png',
            },
            iscategorylink: false,
            psp_url: [],
            categorysfcc: {},
            categorylabel: '',
            link: {
                title: 'simple 3',
                href: '/',
            },
            tags: [],
            locale: 'en',
            created_by: 'blt42386adbe5183fd2',
            updated_by: 'blt42386adbe5183fd2',
            created_at: '2025-02-20T13:31:46.956Z',
            updated_at: '2025-02-20T13:32:06.499Z',
            ACL: {},
            _version: 2,
            _in_progress: false,
            publish_details: {
                time: '2025-02-20T13:32:14.912Z',
                user: 'blt42386adbe5183fd2',
                environment: 'bltb1a0132ae7565d0b',
                locale: 'en',
            },
        },
    ],
}

export const keyFeaturesMockPdp = {
    title: 'Key Features PDP',
    description: 'Key Features Description',
    cards: [
        {
            uid: '1',
            header_copy: 'Key Features Card 1',
            image: {
                url: 'https://eu-images.contentstack.com/v3/assets/blt2252ade9ce4d4191/blte9febca7c08ea2a4/679778e4daf3057e01a09225/moodboard-image.png',
            },
            title: 'Card 1',
            body_copy:
                'Card 1 Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla ornare ligula vitae elit pretium iaculis. Phasellus posuere mauris eget sem laoreet dapibus. Etiam et ultricies metus, atimperdiet velit. Aenean pharetra pellent esque fermentum.',
        },
        {
            uid: '2',
            header_copy: 'Key Features Card 1',
            image: {
                url: 'https://eu-images.contentstack.com/v3/assets/blt2252ade9ce4d4191/blte9febca7c08ea2a4/679778e4daf3057e01a09225/moodboard-image.png',
            },
            title: 'Card 2',
            body_copy:
                'Card 2 Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla ornare ligula vitae elit pretium iaculis. Phasellus posuere mauris eget sem laoreet dapibus. Etiam et ultricies metus, atimperdiet velit. Aenean pharetra pellent esque fermentum.',
        },
        {
            uid: '3',
            header_copy: 'Key Features Card 1',
            image: {
                url: 'https://eu-images.contentstack.com/v3/assets/blt2252ade9ce4d4191/blte9febca7c08ea2a4/679778e4daf3057e01a09225/moodboard-image.png',
            },
            title: 'Card 3',
            body_copy: 'Card 3 Description',
        },
        {
            uid: '4',
            header_copy: 'Key Features Card 1',
            image: {
                url: 'https://eu-images.contentstack.com/v3/assets/blt2252ade9ce4d4191/blte9febca7c08ea2a4/679778e4daf3057e01a09225/moodboard-image.png',
            },
            title: 'Card 4',
            body_copy: 'Card 4 Description',
        },
        {
            uid: '5',
            header_copy: 'Key Features Card 1',
            image: {
                url: 'https://eu-images.contentstack.com/v3/assets/blt2252ade9ce4d4191/blte9febca7c08ea2a4/679778e4daf3057e01a09225/moodboard-image.png',
            },
            title: 'Card 5',
            body_copy: 'Card 5 Description',
        },
        {
            uid: '6',
            header_copy: 'Key Features Card 1',
            image: {
                url: 'https://eu-images.contentstack.com/v3/assets/blt2252ade9ce4d4191/blte9febca7c08ea2a4/679778e4daf3057e01a09225/moodboard-image.png',
            },
            title: 'Card 5',
            body_copy: 'Card 5 Description',
        },
    ],
}
